import React from "react";
import styled from "styled-components";
import { Theme } from "../theme";

/**
 *
 * Example usage:
 *
 * <RadioButtonContainer>
 *    <input type="radio" />
 *    <RadioButtonCheckmark />
 *    <span>My Radio</span>
 * </RadioButtonContainer>
 *
 */

export const RadioButtonCheckmark = styled.span`
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: calc(50% - 10px);
    left: 0;
    width: 20px;
    height: 20px;
    background: ${Theme.colors.gray[700]};

    border: 1px solid ${Theme.colors.gray[700]};
    border-radius: 50%;

    &:after {
        content: "";
        display: none;
    }
`;

RadioButtonCheckmark.displayName = "RadioButtonCheckmark";

export const RadioButtonContainer = styled.label`
    display: block;
    font-size: 14px;
    color: ${Theme.colors.blue};
    position: relative;
    padding-left: 35px;
    margin-top: 20px;
    margin-bottom: 5px;
    cursor: pointer;
    user-select: none;

    input {
        position: absolute;
        opacity: 0;
        cursor: pointer;
    }

    &:hover {
        input ~ ${RadioButtonCheckmark} {
            background: ${Theme.colors.gray[200]};
        }
    }

    input:checked ~ ${RadioButtonCheckmark}:after {
        display: block;
    }

    input:focus-visible ~ ${RadioButtonCheckmark} {
        outline: 3px solid ${Theme.colors.cyan};
    }

    ${RadioButtonCheckmark}:after {
        width: 100%;
        height: 100%;
        transform: scale(0.6);
        border-radius: 50%;
        background: ${Theme.colors.blue};
    }
`;

RadioButtonContainer.displayName = "RadioButtonContainer";

export const RadioButton = styled.input.attrs({ type: "radio" })`
    padding: 10px;
`;

RadioButton.displayName = "RadioButton";
